import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import styled from "styled-components";
import { API_URL } from "./index";
import { RightCalendar } from './RightCalendar';
import queryString from 'query-string';
import { LeftCalendar } from './LeftCalendar';

const Container = styled.div`

  flex: 1 1 auto;

  display: flex;
  
  flex-direction: column;
  
  justify-content: stretch;

  -moz-box-align: stretch;

  align-items: stretch;

  border-radius: 3px;

  background-color: rgb(255, 255, 255);

  margin: 0.5em;

  padding: 0 .5em;
  
  height: 100%;

  overflow: hidden;
  
  font-family: Lato, sans-serif;
  
  @media only screen and (min-width: 1100px) {
   flex-direction: row;
   height: calc(100vh - 1em);
   
  }
  @media only screen and (min-width: 500px) {
   padding: 0 2em;

   
  }

  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 7px 0px;
`;


// const Container2 = styled.div`
//   flex: 1 1 auto;
//
//   overflow-y: hidden;
//
//   background-color: #f3f3f3;
//
//   box-sizing: border-box;
//   display: flex;
//
//   -moz-box-pack: justify;
//
//   justify-content: space-between;
//
//   margin-left: -10px;
//
//   margin-right: -10px;
// `;

const LeftContainer = styled.div`
  padding: .5em;
  width: 100%;
   @media only screen and (min-width: 1100px) {
     width: 35%;

 } 
  @media only screen and (min-width: 500px) {
  padding: 2em;

 }
  overflow-y: auto;
  
  background-color: rgb(255, 255, 255);

  box-sizing: border-box;


`;

const RightContainer = styled.div`
 width: 100%;
 padding: .5em;
  @media only screen and (min-width: 1100px) {
 
  width: 65%;
  
  }
  @media only screen and (min-width: 500px) {
 
  padding: 2em;
  
  }
  
  
  background-color: rgb(255, 255, 255);
  

  box-sizing: border-box;
`;

// const CalendarDescription = styled.div`
//   color: #333;
//   font-family: 'Lato', sans-serif;
//   font-size: 1em;
//   line-height: 1.375em;
//   word-break: break-all;
// `;


const Divider = styled.div`

  height: 100vh;
  width: .5em;
  
  @media only screen and (max-width: 1100px) {
  height: .5em;
  width: 120%;
  margin-left: -2em;
  
  }
  
  
  background-color: #f3f3f3;
`;

const Button = styled.a`
  -moz-box-pack: center;
  justify-content: center;
  -moz-box-align: center;
  align-items: center;
  height: 2.25em;
  padding: 0.625em 0.625em;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: inherit;
  min-width: 5em;
  border: 1px solid rgb(255, 92, 57);
  border-radius: 0.25em;
  background-color: rgb(255, 92, 57);
  color: #fff;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.15s ease 0s, border-color 0.15s ease 0s;
`;

// const FlexDiv = styled.div`
//  display: flex;
//   align-items: center;
// `;

// const SwitchYearIcons = styled.div`
//   font-weight: normal;
//   :hover {
//     cursor: pointer !important;
//
//   }
// `;


interface ICalendarProps {

}

interface ICalendarState {
  data: any;
}

export function Calendar(props: ICalendarProps & RouteComponentProps<{ uri: string }>) {
  const [data, setData] = React.useState();

  let queryParams = queryString.parse(props.location.search);

  let requestUrl = API_URL + '/public/calendar/' + props.match.params.uri + '?template=json';

  if (queryParams.year) {
    requestUrl += '&year=' + queryParams.year;
  }
  if (queryParams.start_month) {
    requestUrl += '&start_month=' + queryParams.start_month;
  }
  if (queryParams.month) {
    requestUrl += '&month=' + queryParams.month;
  }

  useEffect(() => {
    fetch(requestUrl)
      .then(response => response.json())
      .then(dataResponse =>{
        setData(dataResponse);
        document.title = dataResponse.calendar.title;
      });
  }, [requestUrl]);

  return (
    <>
      {data &&
      <Container>
        <LeftContainer>
          <LeftCalendar descriptionText={data?.calendar?.description_text ?? ''} title={data.calendar.title} color={data.calendar.color}
                        description={data?.calendar?.description ?? ''}
          />
        </LeftContainer>
        <Divider/>
        <RightContainer>
          <div style={{textAlign:'right', paddingBottom: '20px'}}>
            <Button href={'https://www.munikum.no/app/calendar/' + data?.calendar?.uri} target={'_blank'}>Åpne årshjul i Munikum</Button>
          </div>
          <RightCalendar
            uri={props.match.params.uri}
            year={data.year}
            previousYear={data.previous_year}
            nextYear={data.next_year}
            calendar={data.calendar}
            months={data.months}
          />
        </RightContainer>
      </Container>
      }
    </>
  );
}
